<template>
  <div class="projector-section">
    <modal ref="modalProjectorInfo">
      <template v-slot:body>
        <div v-html="statusProjector"></div>
      </template>
    </modal>
    <div class="projector-section__container">
      <p class="projector-section__name">
      <slot>projector</slot>
    </p>
    <base-button @click="showStatusProjector">Show status</base-button>
    </div>
    <div class="projector-section__container">
      <base-button @click="clearCacheProjector">Clear cache</base-button>
      <base-button @click="restartProjector">Restart</base-button>
    </div>
  </div>
</template>

<script>
import Modal from '@partials/Modal.vue'
import toast from '@utils/toast.js'
import devicesService from '@/services/devices.js'
import BaseButton from '@/components/common/BaseButton.vue';

export default {
  name: 'ProjectorSection',
  components: { Modal, BaseButton },
  props: {
    idProjector: {
      type: String,
      required: true,
    }
  },  
  data() {
    return {
      statusProjector: "",
    };
  },
  methods: {
    async showStatusProjector() {
      const url = '/admin/get/device/status'
      const body = {
        data: {
          device_id: this.idProjector,
        }
      }
      try {
        const response = await this.request(url, 'POST', body)
        if (response.code === 0) {
          this.statusProjector = response.data.status
          this.$refs.modalProjectorInfo.openModal()
        } else {
          toast.errorMessage(response.message)
        }
      } catch (e) {
        console.error(e);
      }
    },
    async clearCacheProjector() {
      await devicesService.commandDevice('clear', this.idProjector)
    },
    async restartProjector() {
      await devicesService.commandDevice('restart', this.idProjector)
    },
  }
}
</script>

<style>
  .projector-section {
    max-width: 285px;
    margin-top: 40px;
  }

  .projector-section:last-of-type {
    margin-bottom: 20px;
  }
  .projector-section__container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 11px;
  }
  .projector-section__name {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #2B59FF;
    margin: 0;
  }
</style>